export const limit = 50;

export const ACCOUNT_ENUMS = {
  ADMIN: "ADMIN",
  MEMBER: "MEMBER",
  CHARITY: "CHARITY",
};
